import * as React from 'react'
import {
  ArrowTopRightIcon,
  BookmarkFilledIcon,
  BookmarkIcon,
  CopyIcon,
  LockClosedIcon,
  LockOpen1Icon,
  OpenInNewWindowIcon,
  Pencil1Icon,
  TrashIcon,
} from '@radix-ui/react-icons'
import { MenuItem } from '~/sotano-kit/primitives/menu-actions-definitions'
import { Role } from '@basehub/data/replicache/index'
import { ForkIcon } from './fork-icon'

export const getRepoMenuActions = ({
  handleRename,
  handleDelete,
  handleTransfer,
  handleDuplicate,
  openRepo,
  handleFork,
  handleToggleBookmark,
  role = 'member',
  publicRepo,
  isBookmarked,
  togglePublic,
}: {
  handleRename: () => void
  handleDelete: () => void
  handleTransfer: () => void
  handleDuplicate: () => void
  openRepo: () => void
  handleFork: () => void
  handleToggleBookmark: (value: boolean) => void
  role: Role
  publicRepo: boolean
  isBookmarked: boolean
  togglePublic: () => void
}): MenuItem[] => {
  const baseActions: MenuItem[] = [
    {
      key: 'open',
      type: 'action',
      label: 'Open',
      icon: <ArrowTopRightIcon width={16} height={16} />,
      onSelect: openRepo,
      onClick: (e) => e.stopPropagation(),
    },
  ]
  if (role === 'viewer' || role === 'editor') {
    return baseActions
  } else {
    baseActions.push({
      type: 'separator',
      key: 'sep1',
    })
  }

  if (role === 'owner') {
    baseActions.push(
      ...([
        {
          key: 'transfer',
          type: 'action',
          label: 'Transfer ownership',
          icon: <OpenInNewWindowIcon width={16} height={16} />,
          onSelect: handleTransfer,
          onClick: (e) => e.stopPropagation(),
        },
      ] satisfies MenuItem[])
    )
  }

  baseActions.push(
    ...([
      {
        key: 'rename',
        type: 'action',
        label: 'Rename',
        icon: <Pencil1Icon width={16} height={16} />,
        onSelect: handleRename,
        onClick: (e) => e.stopPropagation(),
      },
      {
        key: 'duplicate',
        type: 'action',
        label: 'Duplicate',
        icon: <CopyIcon width={16} height={16} />,
        onSelect: handleDuplicate,
        onClick: (e) => e.stopPropagation(),
      },
      {
        type: 'separator',
        key: 'sep2',
      },
      ...(publicRepo
        ? ([
            {
              key: 'fork',
              type: 'action',
              label: `Fork`,
              icon: <ForkIcon />,
              onSelect: handleFork,
              onClick: (e: any) => e.stopPropagation(),
            },
          ] as const)
        : []),
      {
        key: 'bookmark',
        type: 'action',
        label: isBookmarked ? 'Remove bookmark' : 'Bookmark',
        icon: isBookmarked ? <BookmarkFilledIcon /> : <BookmarkIcon />,
        onSelect: handleToggleBookmark.bind(null, !isBookmarked),
        onClick: (e) => e.stopPropagation(),
      },
      {
        key: 'publish',
        type: 'action',
        label: `Make ${publicRepo ? 'private' : 'public'}`,
        icon: publicRepo ? (
          <LockClosedIcon width={16} height={16} />
        ) : (
          <LockOpen1Icon width={16} height={16} />
        ),
        onSelect: togglePublic,
        onClick: (e) => e.stopPropagation(),
      },
      {
        type: 'separator',
        key: 'sep3',
      },
      {
        key: 'delete',
        type: 'action',
        label: 'Delete',
        icon: <TrashIcon width={16} height={16} />,
        intent: 'danger',
        onSelect: handleDelete,
        onClick: (e) => e.stopPropagation(),
      },
    ] satisfies MenuItem[])
  )

  return baseActions
}
